export class AiExpressionAuthoringApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async explainExpression({
    schemaDomain,
    expressionJson,
    expressionText = null,
    schemaJson = null,
    signal,
  } = {}) {
    const body = { schemaDomain, expressionJson, expressionText, schemaJson };

    return this.#http.post('/ai-expressions/explain', body, { signal });
  }

  async generateExpression({
    schemaDomain,
    expectedRootTypeName,
    description = null,
    currentExpressionJson = null,
    schemaJson = null,
    resumeWithUserAnswer = null,
    resumeThreadMessages = null,
    refinementInstruction = null,
    maxCandidates = null,
    requestId = null,
    signal,
  } = {}) {
    const body = {
      schemaDomain,
      expectedRootTypeName,
      description,
      currentExpressionJson,
      schemaJson,
      resumeWithUserAnswer,
      resumeThreadMessages,
      refinementInstruction,
      maxCandidates,
      requestId,
    };

    return this.#http.post('/ai-expressions/generate', body, { signal });
  }

  async getExpressionGenerationProgress({ requestId, signal } = {}) {
    return this.#http.get(`/ai-expressions/generate/progress/${encodeURIComponent(requestId)}`, {
      signal,
    });
  }

  async submitExpressionGenerationFeedback({
    aiUsageMetricsId,
    outcome,
    comment = null,
    tags = null,
    signal,
  } = {}) {
    const body = { aiUsageMetricsId, outcome, comment, tags };

    return this.#http.post('/ai-expressions/feedback', body, { signal });
  }
}
